import { getRandomMessage } from './activitiesData';

// Create confetti animation
export function createConfetti() {
  const container = document.createElement('div');
  container.className = 'confetti-container';
  document.body.appendChild(container);

  const colors = ['#FFB347', '#FF6B6B', '#98D8C8', '#F7DC6F', '#BB8FCE', '#FFB6C1', '#87CEEB', '#DDA0DD'];
  const shapes = ['square', 'circle', 'strip'];

  // Create confetti pieces
  for (let i = 0; i < 50; i++) {
    const confetti = document.createElement('div');
    const shape = shapes[Math.floor(Math.random() * shapes.length)];
    confetti.className = `confetti ${shape}`;

    const startX = Math.random() * 100;
    const fallDuration = 2 + Math.random() * 2;
    const rotation = 360 + Math.random() * 720;
    const delay = Math.random() * 0.5;

    confetti.style.cssText = `
      left: ${startX}%;
      background: ${colors[Math.floor(Math.random() * colors.length)]};
      --fall-duration: ${fallDuration}s;
      --rotation: ${rotation}deg;
      animation-delay: ${delay}s;
    `;

    container.appendChild(confetti);
  }

  // Remove container after animation
  setTimeout(() => container.remove(), 4000);
}

// Show toast notification
export function showToast(message) {
  // Remove existing toast if any
  const existing = document.querySelector('.celebration-toast');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.className = 'celebration-toast';
  toast.innerHTML = `
    <span class="toast-emoji">🎉</span>
    <span class="toast-message">${message}</span>
  `;

  document.body.appendChild(toast);

  // Trigger show animation
  requestAnimationFrame(() => {
    toast.classList.add('show');
  });

  // Hide after 4 seconds
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 500);
  }, 4000);
}

// Celebrate when an activity is added to calendar
export function celebrateActivityDrop(experienceCount) {
  createConfetti();

  const message = getRandomMessage();
  showToast(`${message} (${experienceCount} experiences planned)`);
}
